var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "absolute z-0 bg-gray-200 dark:bg-gray-700 rounded-full m-auto items-center content-center mt-6 cursor-pointer",
      style: `width: ${_vm.width}px; margin-left :${_vm.marginLeft}px;height:32px`,
      attrs: { id: _vm.width.toString() },
      on: { click: _vm.handleProgresBarClick },
    },
    [
      _c("div", {
        staticClass: "rounded-r-full",
        style: `margin-left: ${_vm.innerMarginLeft}px; width: ${_vm.remainingWidth}%; height:32px; background-color:${_vm.color}`,
      }),
      _vm.item.project_activities
        ? _c("div", { staticClass: "flex -mt-8 ml-2" }, [
            _c(
              "div",
              { staticClass: "flex items-center" },
              _vm._l(_vm.item.project_activities, function (activity) {
                return _c("div", { key: activity.id }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "rounded-full transform hover:scale-125 border border-white bg-white cursor-pointer -m-1 mt-0.5",
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            title: _vm.getContractorFullname(
                              activity.contractor.user
                            ),
                            variant: _vm.TooltipVariants.DARK,
                            placement: "right",
                          },
                        },
                        [
                          activity.contractor.user.avatar
                            ? [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: {
                                      to: {
                                        name: _vm.routes
                                          .CONTRACTOR_DETAILS_ABOUT,
                                        params: { id: activity.contractor.id },
                                      },
                                    },
                                  },
                                  [
                                    _vm._t(
                                      "image",
                                      function () {
                                        return [
                                          _c("S3Image", {
                                            class: [
                                              _vm.defaultImageClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            attrs: {
                                              s3FileKey:
                                                activity.contractor.user.avatar,
                                            },
                                          }),
                                        ]
                                      },
                                      {
                                        defaultClasses: [
                                          _vm.defaultImageClasses,
                                          _vm.avatarStyleClasses,
                                        ],
                                        image: activity.contractor.user.avatar,
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            : [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: {
                                      to: {
                                        name: _vm.routes
                                          .CONTRACTOR_DETAILS_ABOUT,
                                        params: { id: activity.contractor.id },
                                      },
                                    },
                                  },
                                  [
                                    _vm._t(
                                      "initial",
                                      function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-xs font-semibold inline-block py-1 px-2 rounded-full last:mr-0 mr-1",
                                              class: [
                                                _vm.defaultInitialsClasses,
                                                _vm.avatarStyleClasses,
                                              ],
                                              style: _vm.bgStyle,
                                            },
                                            [
                                              activity.contractor.user &&
                                              activity.contractor.user
                                                .given_name &&
                                              activity.contractor.user
                                                .family_name
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-xs leading-none font-bold text-white",
                                                      style: _vm.bgStyle,
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          activity.contractor.user.given_name
                                                            .trimStart()[0]
                                                            .toUpperCase()
                                                        ) +
                                                          _vm._s(
                                                            activity.contractor.user.family_name
                                                              .trimStart()[0]
                                                              .toUpperCase()
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-sm leading-none text-white",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.initial) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      },
                                      {
                                        defaultClasses: [
                                          _vm.defaultInitialsClasses,
                                          _vm.avatarStyleClasses,
                                        ],
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.showProjectModal
        ? _c("ProjectModal", {
            attrs: {
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
              data: _vm.projectInfoForModal,
              isEdittingLocked: _vm.isEdittingLocked,
            },
            on: {
              close: _vm.handleCloseModal,
              projectUpdated: _vm.refetchCollection,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customHeader",
                  fn: function ({ title }) {
                    return [
                      _c("SchedulerCustomModalHeader", {
                        attrs: {
                          linkObject: _vm.linkToProject,
                          buttonText: title,
                          isEdittingLocked: _vm.isEdittingLocked,
                        },
                        on: { editClicked: _vm.handleEditClick },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              4128683522
            ),
          })
        : _vm._e(),
      _vm.showActivityModal
        ? _c("ActivityFormModal", {
            attrs: {
              showDialog: _vm.modalShown,
              project: _vm.projectInfoForModal,
              projectActivity: _vm.activityInfoForModal,
              isEdittingLocked: _vm.shouldBlockEditting,
              currentUserRole: _vm.currentUser.role,
              companyId: _vm.companyId,
            },
            on: {
              close: _vm.handleCloseModal,
              activityUpdated: _vm.handleCollectionUpdated,
              activityAdded: _vm.handleCollectionUpdated,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customHeader",
                  fn: function ({ title }) {
                    return [
                      _c("SchedulerCustomModalHeader", {
                        attrs: {
                          linkObject: _vm.linkToProjectActivities,
                          buttonText: title,
                          isEdittingLocked: _vm.shouldBlockEditting,
                          linkText: "Go To Project Activities List",
                        },
                        on: { editClicked: _vm.handleEditClick },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1051539805
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }